<template>
    <v-container class="pa-0 ma-0" fluid flat style="width: 100%">
        <v-card flat color="#FFD375">
            <v-container class="pa-2 ma-2" style="height: 5%;">
                <v-row class="pa-0 ma-0">
                    <v-col cols="3">
                        <v-container class="py-0 my-0">
                            <v-row class="py-0 my-0">
                                <div class="text-center px-10 py-0 my-0">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-btn :disabled=noGroups color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">sort</v-icon>{{sorttitle}}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item v-for="(item, index) in sortitems" :key="index" @click="setSort(item)">
                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>

            <v-card class="pa-0 ma-0" flat style="width: 600px" tile>
                <v-list :key="this.$store.state.updatecount" two-line class="bckgrnd pa-0 ma-0" flat>
                    <v-content>
                        <v-list-item-content v-model="item" color="#000000">
                            <v-list-item v-for="(group, i) in groups" :key="i">
                                <v-row :class='rowClass(group)' @click='rowClicked(group)'>
                                    <v-col cols="8">
                                        <v-list-item-content>
                                            <v-list-item-title class="boldtext" v-text="group.Name"></v-list-item-title>
                                            <v-list-item-subtitle class="smalltext" v-text="contactCount(group)"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="4" class="text-right">
                                        <v-container>
                                            <v-list-item-icon class="px-2 py-0 ma-0" v-if="group.IsSelected" @click='editClicked(group)'>
                                                <v-icon color="#000000">edit</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon class="pa-0 ma-0" v-if="group.IsSelected" @click='deleteClicked(group)'>
                                                <v-icon color="#000000">delete_forever</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon class="pa-0 ma-0" v-if="group.IsSelected" @click='manageClicked(group)'>
                                                <v-icon color="#000000">account_tree</v-icon>
                                            </v-list-item-icon>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list-item-content>
                    </v-content>
                </v-list>
            </v-card>

            <GroupPopup v-bind:selectedgroup=selectedgroup v-model="showGroupPopup" />
            <GroupContactsPopup v-bind:group=selectedgroup v-model="showGroupContactsPopup" />
        </v-card>
    </v-container>
</template>

<script>

    import GroupPopup from '@/views/Manage/Groups/GroupPopup';
    import GroupContactsPopup from '@/views/Manage/Groups/GroupContactsPopup';

    export default {
        data: () => ({
            sortitems: [
                { title: 'Name A..Z', prop: 'Name', dir: 'Up'},
                { title: 'Name Z..A', prop: 'Name', dir: 'Down' }
            ],
            sorttitle: 'Sort...',
            item: null,
            contactdata: {},
            selectedgroup: null,
            showGroupPopup: false,
            showGroupContactsPopup: false
        }),
        components: {
            GroupPopup,
            GroupContactsPopup
        },
        methods: {
            setSort(param) {
                this.sorttitle = "Sort by " + param.title;
                if (param.dir === 'Up')
                    this.groups.sort((a, b) => a[param.prop] < b[param.prop] ? -1 : 1);
                else
                    this.groups.sort((a, b) => a[param.prop] > b[param.prop] ? -1 : 1);
            },
            rowClicked(group) {
                if (this.selectedgroup != null)
                    this.selectedgroup.IsSelected = false;
                group.IsSelected = true;
                this.selectedgroup = group;
                this.$store.state.selectedgroup = group;
            },
            editClicked(group) {
                this.showGroupPopup = true;
            },
            deleteClicked(group) {
                this.$root.$confirm('Confirm', 'Are you sure you want to delete this group?', { color: '#FFA500' }).then((confirm) => {
                    if (confirm) {
                        this.$store.dispatch('cutGroup', group);
                    }
                })
            },
            manageClicked(group) {
                this.showGroupContactsPopup = true;
            },
            rowClass(group) {
                if (group.IsSelected)
                    return 'selectedtile';
                else
                    return 'tile';
            },
            contactCount(group) {
                if (group.Contacts == null)
                    return '(Includes 0 contacts)';
                if (group.Contacts.length == 1)
                    return '(Includes 1 contact)';
                return '(Includes ' + group.Contacts.length + ' contacts)';
            }
        },
        computed: {
            noGroups() {
                if (!this.groups)
                    return true;
                if (this.groups.length < 1)
                    return true;
                else
                    return false;
            },
            groups() {
                return this.$store.state.groups;
            }
        }
    }
</script>

<style scoped>
    .tile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

        .tile:hover {
            background: #FFD375;
        }

        .tile:active {
            background: #FFD375;
        }

    .selectedtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

    .bckgrnd {
        background: #FFD375;
    }

    .boldtext {
        color: black;
        font-size: large;
        font-weight: bold;
    }

    .smalltext {
        color: darkslategray;
        font-size: small;
        margin-top: 4px;
    }
</style>

